export default __webpack_public_path__ + "static/media/banner-gk.26b5e474.jpeg";